"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const components = require("./Utility/ComponentRegister");
const Config = require("./Config/Config");
class App {
    constructor() {
        this._isInitialized = false;
    }
    async initializeApp(option) {
        if (option.stage) {
            Config.setStage(option.stage);
        }
        try {
            await components.get('Authorization').initialize();
            await components.get('Device').initialize();
        }
        catch (err) {
            console.log(err);
        }
        finally {
            this._isInitialized = true;
        }
    }
    get isInitialized() {
        return this._isInitialized;
    }
    get activityService() {
        this.checkInitialize();
        return components.get('ActivityService');
    }
    get auth() {
        this.checkInitialize();
        return components.get('Authorization');
    }
    get carouselBanner() {
        this.checkInitialize();
        return components.get('CarouselBanner');
    }
    get database() {
        this.checkInitialize();
        return components.get('Database');
    }
    get device() {
        this.checkInitialize();
        return components.get('Device');
    }
    get enquire() {
        this.checkInitialize();
        return components.get('Enquire');
    }
    get newsPage() {
        this.checkInitialize();
        return components.get('NewsPage');
    }
    get paymentService() {
        this.checkInitialize();
        return components.get('PaymentService');
    }
    get repairOrder() {
        this.checkInitialize();
        return components.get('RepairOrder');
    }
    get selectedArticle() {
        this.checkInitialize();
        return components.get('SelectedArticle');
    }
    get services() {
        this.checkInitialize();
        return components.get('Services');
    }
    get quotation() {
        this.checkInitialize();
        return components.get('Quotation');
    }
    get statistic() {
        this.checkInitialize();
        return components.get('StatisticService');
    }
    checkInitialize() {
        if (!this._isInitialized) {
            throw new Error('App is not initialize');
        }
    }
}
exports.default = App;
//# sourceMappingURL=App.js.map